import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Dictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type SupplyLandState = Readonly<{
    qtyOrdered: number;
    variantPrices: Dictionary<ProductPriceDto>;
}>;

const initialCounterState: SupplyLandState = {
    qtyOrdered: 1,
    variantPrices: <Dictionary<ProductPriceDto>>{},
};

const supplyLandData = createTypedReducerWithImmer(initialCounterState, {
    "SupplyLand/VariantTable/ChangeQtyOrdered": (
        draft: Draft<SupplyLandState>,
        action: { qtyOrdered: number; productId: string },
    ) => {
        if (draft.qtyOrdered === action.qtyOrdered) {
            draft.qtyOrdered = 1;
        } else {
            draft.qtyOrdered = action.qtyOrdered;
        }
    },
    "SupplyLand/VariantPrices": (draft: Draft<SupplyLandState>, action: { prices: Dictionary<ProductPriceDto> }) => {
        draft.variantPrices = action.prices;
    },
});

export default (reducers as any).supplyLandData = supplyLandData;

export type CustomState = {
    supplyLandData: SupplyLandState;
} & ApplicationState;

type Reducers = {
    supplyLandData: typeof supplyLandData;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
